"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lruMemoize = require("lru-memoize");

var _lruMemoize2 = _interopRequireDefault(_lruMemoize);

var _validation = require("../../utils/validation");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var registrationValidation = (0, _validation.createValidator)({
  email: [_validation.required, _validation.email],
  first_name: _validation.required,
  last_name: _validation.required,
  phone: _validation.required,
  password: [_validation.required, (0, _validation.minLength)(8)],
  password2: [_validation.required, (0, _validation.matchPasswords)("password")],
  tos_accepted: _validation.required,
  address: (0, _validation.requiredIf)("profile", "COMPANY"),
  postal_code: (0, _validation.requiredIf)("profile", "COMPANY"),
  postal_area: (0, _validation.requiredIf)("profile", "COMPANY"),
  profile: _validation.required,
  business_id: [(0, _validation.requiredIf)("profile", "COMPANY"), _validation.businessId],
  company_name: (0, _validation.requiredIf)("profile", "COMPANY")
});
exports.default = (0, _lruMemoize2.default)(10)(registrationValidation);
module.exports = exports["default"];


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/Registration/registrationValidator.js
 ** module id = 1242
 ** module chunks = 0
 **/